import React, { useState, useEffect } from 'react';
import './MultilingualButton.css';

const MultilingualButton = ({
  children,
  className = '',
  onClick,
  isLoggedIn,
  icon,
  ...props
}) => {
  const [currentLang, setCurrentLang] = useState(0);

  // Enhanced translations with shorter text and more languages
  const translations = {
    'Share Your Prediction or Expectation': {
      en: 'Share Prediction',
      fr: 'Partager Prédiction',
      de: 'Vorhersage Teilen',
      es: 'Compartir Predicción',
      it: 'Condividi Previsione',
      pt: 'Compartilhar Previsão',
      fa: 'اشتراک پیش‌بینی', // Persian
      zh: '分享预测', // Chinese
      ru: 'Поделиться' // Russian
    },
    'Join & Predict': {
      en: 'Join & Predict',
      fr: 'Rejoindre',
      de: 'Beitreten',
      es: 'Únete',
      it: 'Unisciti',
      pt: 'Junte-se',
      fa: 'عضویت و پیش‌بینی', // Persian
      zh: '加入预测', // Chinese
      ru: 'Присоединиться' // Russian
    }
  };

  const languages = ['en', 'fr', 'de', 'es', 'it', 'pt', 'fa', 'zh', 'ru'];

  // Get translation for current text and language
  const getTranslation = (text) => {
    if (!translations[text]) return text;
    const langKey = languages[currentLang];
    return translations[text][langKey] || text;
  };

  // Auto-rotate languages
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentLang((prev) => (prev + 1) % languages.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  // Handle button click
  const handleClick = (e) => {
    if (onClick) onClick(e);
  };

  return (
    <button 
      className={`multilingual-button ${className}`}
      onClick={handleClick}
      {...props}
    >
      <div className="button-content">
        {icon && <span className="button-icon">{icon}</span>}
        <span className="button-text">
          {getTranslation(children)}
        </span>
      </div>
    </button>
  );
};

export default MultilingualButton;
